import React from 'react';
import classNames from 'classnames';
import './index.less.js';

var TiFormGroup = function TiFormGroup(props) {
  var children = props.children,
    className = props.className,
    style = props.style,
    extra = props.extra,
    title = props.title;
  var formGroupCls = classNames('ti-form-group', className);
  return /*#__PURE__*/React.createElement("div", {
    className: formGroupCls,
    style: style
  }, title ? /*#__PURE__*/React.createElement("div", {
    className: "ti-form-group-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ti-form-group-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ti-form-group-title-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ti-form-group-title-content"
  }, title)), extra ? /*#__PURE__*/React.createElement("div", {
    className: "ti-form-group-extra"
  }, extra) : null) : null, children);
};

export { TiFormGroup as default };
